import { BrandliveEvent } from '@/types/projects.types';
import { getDefaultLanguage } from './get-default-language';
import getProjectNameURL from './get-project-name-url';
import eventPath from './event-path';
import getPrefixUrl from './get-prefix-url';
import { Channel } from '@/types/channel.types';
import { stageEnvironment } from './urls';

type CopyEventUrlProps = {
  channel?: Channel | null;
  event?: BrandliveEvent | null;
  publishedUrl?: string;
  sessionUuid?: string;
  language?: string;
};

const copyEventUrl = ({ channel, event, language, publishedUrl, sessionUuid }: CopyEventUrlProps) => {
  if (!event || !channel) return false;

  const isLocalEnv = stageEnvironment.isLocal;
  let eventLink = '';
  const eventUuid = event.uuid;

  const _language = language || getDefaultLanguage(event);

  if (isLocalEnv) {
    eventLink = `localhost:3000/event/${eventUuid}/${_language}`;
  } else {
    const eventUrl = publishedUrl ? publishedUrl : getProjectNameURL(event);
    const eventName = eventPath(eventUrl, eventUuid);
    eventLink = `${getPrefixUrl(channel.url)}/${eventName}/${_language}`;
  }

  if (sessionUuid) {
    eventLink += `/session/${sessionUuid}`;
  }

  navigator.clipboard.writeText(eventLink);

  return true;
};

export default copyEventUrl;
